import React, { FC } from 'react';
import PropTypes from 'prop-types';

import CustomTooltip from '../../CustomTooltip';
import * as Styled from './styles';

interface IProps {
    value: string,
    label: string,
    isDisabled: boolean,
    tooltipText: string,
}

const FormatOptionLabel: FC<IProps> = ({ value, label, isDisabled, tooltipText }) => (
    <Styled.FormatOptionLabelContainer data-tip data-for={value} isDisabled={isDisabled}>
        <div>{label}</div>
        {isDisabled && (
            <>
                <Styled.Icon icon="star" />
                <CustomTooltip
                    dataRef={value}
                    text={tooltipText}
                    place="bottom"
                    icon="lock-alt"
                    width={136}
                    effect="solid"
                    offset={{ right: 4 }}
                />
            </>
        )}
    </Styled.FormatOptionLabelContainer>
);

FormatOptionLabel.propTypes = {
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    tooltipText: PropTypes.string.isRequired,
};

export default FormatOptionLabel;
